const IsIslandBrowser = () => {
  // Original implementation below:
  // Island might not identify itself in the user agent string
  // Try to detect Island-specific features instead
  
  // Method 1: Check if Island-specific global variable exists
  if (window.isIslandBrowser || window.__ISLAND_BROWSER__) {
    console.log('condition 1 - window.isIslandBrowser and window.__ISLAND_BROWSER__', window.isIslandBrowser, window.__ISLAND_BROWSER__);
    return true;
  }
  
  // Method 2: Check for Island-specific navigator properties
  // Replace these with actual Island-specific properties if known
  if (navigator.userAgentData?.brands?.some(brand => 
    brand.brand.includes('Island'))) {
    console.log('condition 2 - navigator.userAgentData?.brands?.some(brand => brand.brand.includes("Island"))', navigator.userAgentData?.brands);
    return true;
  }
  
  // Method 3: If on a controlled domain, assume it's Island
  // If your app will only be deployed to Island-controlled domains
  if (window.location.hostname.includes('island') || 
      window.location.hostname.endsWith('.island.com')) {
    console.log('condition 3 - window.location.hostname.includes("island") || window.location.hostname.endsWith(".island.com")', window.location.hostname);
    return true;
  }
  
  // Fallback: Ask the user or enable a debug flag
  // For testing, you could use a URL parameter
  if (new URLSearchParams(window.location.search).has('island-mode')) {
    console.log('condition 4 - new URLSearchParams(window.location.search).has("island-mode")', new URLSearchParams(window.location.search).has('island-mode'));
    return true;
  }
  
  // Default fallback - not detected as Island
  console.log('condition 5 - not detected as Island - default fallback');
  return true;
};

export default IsIslandBrowser;